import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PutProcessStatusRequestModel, PutProcessStatusResponseModel } from "@/features/accounts/ocr/services/put-process-status-model";

export class PutProcessStatusApi {
  /**
   * OCR読み取り状況更新API
   */
  public PutProcessStatus = async (
    param: PutProcessStatusRequestModel
  ): Promise<PutProcessStatusResponseModel> => {
    const path = `/api/ocraccounts/status`;

    const res = await ApiClient.instance.put<PutProcessStatusResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
